import styled from "styled-components";
interface InputProps {
    tipoPessoa?: string;
}

export const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    background: ${({ theme }) => theme.colors.interfacePure100};
    display: flex;
    flex-direction: column;
    position: relative;

    .loader {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        backdrop-filter: blur(2px);
    }
`;

export const Header = styled.div`
    width: 100%;
    padding: 20px 128px;
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.colors.interfacePure100};

    @media (max-width: 768px) {
        padding: 16px 24px;
    }

    .logo-icon{
        width: 160px;
    }
`;

export const Main = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 24px;
    background: ${({ theme }) => theme.colors.interfacePure100};

    @media (max-width: 768px) {
        padding: 24px 16px;
    }
`;

export const FormContainer = styled.div`
    width: 100%;
    max-width: 800px;
    background: ${({ theme }) => theme.colors.interfacePure0};
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    svg{
        margin-top: 30px;
    }
`;

export const FormTitle = styled.div`
    padding: 32px 40px 24px;
    text-align: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.interfaceGray200};

    h1 {
        font-size: 28px;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.interfaceGray400};
        margin-bottom: 8px;
        line-height: 1.2;
    }

    p {
        font-size: 16px;
        color: ${({ theme }) => theme.colors.interfaceGray500};
        line-height: 1.4;
    }

    @media (max-width: 768px) {
        padding: 24px 24px 20px;

        h1 {
            font-size: 24px;
        }

        p {
            font-size: 14px;
        }
    }
`;

export const FormContent = styled.div<InputProps>`
    padding: 32px 40px;
    height: ${({ tipoPessoa }) => tipoPessoa === 'juridica' ? '800px' : '700px'};

    @media (max-width: 768px) {
        padding: 24px;
        height: 100%;
    }

    .form-section {
        h2 {
            font-size: 20px;
            font-weight: 600;
            color: ${({ theme }) => theme.colors.interfaceGray400};
            margin-bottom: 24px;
            padding-bottom: 12px;
        }
    }
`;

export const CheckboxContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 32px;

    .error {
        font-size: 12px;
        color: ${({ theme }) => theme.colors.primaryRed400};
        margin-left: 24px;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;

    button {
        background: ${({ theme }) => theme.colors.primaryRed400};
        color: ${({ theme }) => theme.colors.interfacePure0};
        border: none;
        border-radius: 8px;
        padding: 16px 48px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s;
        min-width: 200px;

        &:hover:not(:disabled) {
            background: ${({ theme }) => theme.colors.primaryRed500};
        }

        &:disabled {
            background: ${({ theme }) => theme.colors.interfaceGray300};
            cursor: not-allowed;
        }

        @media (max-width: 768px) {
            width: 100%;
            padding: 14px 24px;
            font-size: 14px;
        }
    }
`;